"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["platform", "base", "type", "user", "repo", "interval", "variant", "version", "branch"];
var Activity = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'github' : _props$platform,
    _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    _props$type = props.type,
    type = _props$type === void 0 ? 'commits-since' : _props$type,
    user = props.user,
    repo = props.repo,
    interval = props.interval,
    variant = props.variant,
    version = props.version,
    branch = props.branch,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'github') return '';
    if (type === 'commits-since' && version && branch) {
      return [base, platform, type, user, repo, version, branch].join('/');
    }
    if (type === 'commit-activity' && interval) {
      return [base, platform, type, interval, user, repo].join('/');
    }
    if (type === 'variant' && variant) {
      return [base, platform, type, variant, user, repo].join('/');
    }
    if (type === 'last-commit') {
      return branch ? [base, platform, type, user, repo, branch].join('/') : [base, platform, type, user, repo].join('/');
    }
    if (type && /^release-(date|date-pre)/.test(type)) {
      return [base, platform, type, user, repo].join('/');
    }
    return '';
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Activity.displayName = 'Activity';
var _default = exports["default"] = Activity;
module.exports = exports.default;